import styles from './CardListWrapper.sass'

export const CardListWrapper = ({ children }) =>
  <div className={styles.listContainer}>
    {children}
  </div>

